import {antiForgeryPost} from '../../../utils/fetch';
import ko from 'knockout';

function EmailOptionsViewModel(data){
    const unsubSelectedValue = 'unsubscribe';

    this.email = ko.observable();
    this.options = ko.observableArray([
        {
            displayText: 'Please change the frequency',
            value: 'frequency'
        },
        {
            displayText: 'Please unsubscribe me',
            value: unsubSelectedValue
        }
    ]);
    this.frequency = ko.observableArray(data.frequency);
    this.selectedFrequency = ko.observable();
    this.selectedOption = ko.observable();

    this.showFrequencyOptions = ko.observable(false);

    this.selectedOption.subscribe(option => {
        if(option === unsubSelectedValue){
            this.selectedFrequency(undefined);
            this.showFrequencyOptions(false);
        }else{
            this.showFrequencyOptions(true);
        }
    });
}

EmailOptionsViewModel.prototype.save = function(){
    if(this.selectedOption() === 'frequency'){
        return antiForgeryPost('/api/CustomerContact/EmailSubscribe', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'email': this.email(),
                'frequency': this.selectedFrequency()
            })
        })
        .then(function(response){
            return response.json();
        })
        .catch(function(){
            // eslint-disable-next-line no-console
            console.error('A call to \'/api/CustomerContact/EmailSubscribe\' failed');
        });
    }

    return antiForgeryPost('/api/CustomerContact/Unsubscribe', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'       
        },
        body: JSON.stringify({
            Email: this.email()
        })
    })
    .then(function(response){
        return response.json();
    })
    .catch(function(){
        // eslint-disable-next-line no-console
        console.error('A call to \'/api/CustomerContact/Unsubscribe\' failed');
    });
};

export default EmailOptionsViewModel;